<app-simple-stacked-bar-chart
  [data]="data"
  [loading]="isLoading"
  [leftLabel]="'charts.labels.tutor' | translate"
  [rightLabel]="'charts.labels.total_events' | translate"
></app-simple-stacked-bar-chart>
